import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useYear } from "../../contexts/YearContext";
import { useArea } from "../../contexts/AreaContext";
import { useEntity } from "../../contexts/EntityContext";
import "./AcoesPageComponent.css";

const AcoesPageComponent: React.FC = () => {
    const history = useHistory();
    const { currentYear, clearCurrentYear } = useYear();
    const { currentEntity } = useEntity();
    const { availableAreas, loading: areasLoading, error: areasError, fetchAvailableAreas, setCurrentArea, clearCurrentArea } = useArea();

    useEffect(() => {
        if (currentEntity) {
            fetchAvailableAreas(currentEntity.entidade_id);
        }
    }, [currentEntity, fetchAvailableAreas]);

    const handleNavigation = async (area: any) => {
        try {
            await setCurrentArea(area);

            if (!currentYear) {
                history.push('/ano', {
                    returnPath: `/acoes/${area.area_id}`,
                    returnTo: 'acoes'
                });
            } else {
                history.push(`/acoes/${area.area_id}`);
            }
        } catch (error) {
            console.error('Error setting current area:', error);
        }
    };

    const visibleAreas = availableAreas;

    return (
        <Container className="mt-4">
            <Button
                variant="outline-secondary"
                onClick={() => {
                    clearCurrentArea();
                    clearCurrentYear();
                    history.push('/home/modulo');
                }}
                className="return-button mb-3 d-flex align-items-center gap-2"
            >
                <span>←</span> Voltar
            </Button>

            <div className="mb-4">
                <h4>GERENCIADOR DE AÇÕES</h4>
            </div>

            {areasLoading && (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </div>
                </div>
            )}

            {areasError && (
                <div className="alert alert-danger" role="alert">
                    {areasError}
                </div>
            )}

            {!areasLoading && !areasError && (
                <>
                    {visibleAreas.length === 0 ? (
                        <div className="text-center py-5">
                            <div className="mb-3">
                                <i className="mdi mdi-folder-outline fa-3x text-muted"></i>
                            </div>
                            <h5 className="text-muted mb-3">Nenhuma Área Disponível</h5>
                            <p className="text-muted mb-0">
                                Você não é responsável por nenhuma questão, item ou ação no momento.
                            </p>
                            <p className="text-muted">
                                Entre em contato com o administrador da entidade ou responsável pela área caso tenha dúvidas.
                            </p>
                        </div>
                    ) : (
                        <Row className="g-4">
                            {visibleAreas.map((area) => (
                                <Col md={6} key={area.area_id}>
                                    <Card
                                        className="entity-card"
                                        onClick={() => handleNavigation(area)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <Card.Body className="d-flex justify-content-between align-items-center p-4">
                                            <div>
                                                <Card.Title className="text-dark mb-2">{area.nome}</Card.Title>
                                                <Card.Text className="text-muted mb-0">
                                                    Status: {area.status}
                                                </Card.Text>
                                            </div>
                                            {/* <div className="icon-container" style={{
                                                width: '40px',
                                                height: '40px',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '1.5rem',
                                                color: '#000000',
                                                transition: 'all 0.2s ease'
                                            }}>
                                                <i className="mdi mdi-folder" style={{ fontSize: '2rem' }}></i>
                                            </div> */}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    )}
                </>
            )}
        </Container>
    );
};

export default AcoesPageComponent;
